import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { sendAutoPlayData } from '../../../redux/slices/autoPlaySlice';
import { X } from 'lucide-react';

const sliderThumbClass = "bg-[#F8B731] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:bg-[#F8B731] [&::-webkit-slider-thumb]:rounded-full [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:bg-[#F8B731] [&::-moz-range-thumb]:rounded-full"

const AutoPlay = ({ balance, setAutoPlay, countAutoPlay, setCountAutoPlay, onClose, handleSpinCallback, setAutoPlayLimit }) => {

    const dispatch = useDispatch();

    const autoSpins = [5, 10, 25, 50, 75, 100, 250, 500, 1000, -1]
    const [autoSpin, setAutoSpin] = useState(false)
    const [lossLimit, setLossLimit] = useState(0)
    const [winLimit, setWinLimit] = useState(0)

    const handleAutoPlay = async () => {
        const lossLimitBalance = lossLimit === 0 ? balance : balance - (lossLimit / 100) * balance;
        const winLimitBalance = winLimit === 0 ? balance : balance + (winLimit / 100) * balance;

        if (autoSpin && balance > lossLimitBalance && balance < winLimitBalance) {

            setAutoPlayLimit({
                winLimit: winLimitBalance.toFixed(2),
                lossLimit: lossLimitBalance.toFixed(2),
            })

            const autoPlayData = {
                winBalanceLimitForAutoSpin: winLimitBalance.toFixed(2),
                lossBalanceLimitForAutoSpin: lossLimitBalance.toFixed(2),
                autoSpin: true,
            };

            try {
                const response = await dispatch(sendAutoPlayData(autoPlayData)).unwrap();
                if (response.success) {
                    setAutoPlay(true);
                    handleSpinCallback()
                    if (countAutoPlay !== -1) {
                        setCountAutoPlay(countAutoPlay - 1)
                    }
                    onClose();
                }
            } catch (error) {
                console.error("Error Response:", error);
            }
        }
    };

    return (
        <div className="h-full w-full text-white">
            <div className="w-full h-[10%] mb-2 text-white flex items-center justify-center relative xs:text-lg sm:text-lg md:text-2xl lg:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-5xl font-bold border-b border-gray-500">
                <span className="absolute left-1/2 transform -translate-x-1/2">Auto Play</span>
                <button
                    className="absolute right-4 text-gray-50 bg-slate-700 p-1 hover:text-gray-300 text-xl rounded-full"
                    onClick={onClose}
                >
                    <X className="xs:w-2 xs:h-2 sm:w-3 sm:h-3 md:w-4 md:h-4 lg:w-7 lg:h-7 2xl:w-9 2xl:h-9 3xl:w-12 3xl:h-12" />
                </button>
            </div>
            <div className="flex flex-row h-[90%] text-base sm:text-lg md:text-xl xl:text-2xl xs:m-1 md:m-4 overflow-hidden">
                {/* Bet Value Section */}
                <div className={`xs:p-1 lg:p-3 xs:mx-1 md:mx-3 lg:mx-8 2xl:mx-20 w-full flex flex-col items-center xs:text-xs md:text-md lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl ${autoSpin ? "text-gray-50" : "text-gray-500"}`}>
                    <div className="mb-2 text-center font-semibold">Bet Value</div>

                    <div className="flex flex-col items-center w-full max-w-screen-xl xs:my-0 lg:my-4 2xl:my-8">
                        {/* Loss Limit in Percentage */}
                        <div className="flex items-center justify-between w-full mb-1">
                            <span className="font-semibold">Loss Limit</span>
                            <span className="font-semibold">{lossLimit === 0 ? "Off" : `${lossLimit.toFixed(2)}%`}</span>
                        </div>
                        <input
                            type="range"
                            min="0"
                            max="100"
                            value={lossLimit}
                            onChange={(e) => setLossLimit(Number(e.target.value))} // Updates percentage
                            disabled={!autoSpin}
                            className={`w-full h-2 rounded-lg appearance-none cursor-pointer transition-all ${autoSpin ? sliderThumbClass : "bg-gray-500 opacity-50 cursor-not-allowed"
                                }`}
                            style={{
                                background: `linear-gradient(to right, #F8B731 ${lossLimit}%, #6B7280 ${lossLimit}%)`
                            }}
                        />
                    </div>

                    <div className="flex flex-col items-center w-full max-w-screen-xl mt-2 xs:my-0 lg:my-4 2xl:my-8">
                        {/* Win Limit in Percentage */}
                        <div className="flex items-center justify-between w-full mb-1">
                            <span className="font-semibold">Win Limit</span>
                            <span className="font-semibold">{winLimit === 0 ? "Off" : `${winLimit.toFixed(2)}%`}</span>
                        </div>
                        <input
                            type="range"
                            min="0"
                            max="100"
                            value={winLimit.toFixed(2)}
                            onChange={(e) => setWinLimit(Number(e.target.value))}  // Updates percentage
                            disabled={!autoSpin}
                            className={`w-full h-2 rounded-lg appearance-none cursor-pointer transition-all ${autoSpin ? sliderThumbClass : "bg-gray-500 opacity-50 cursor-not-allowed"
                                }`}
                            style={{
                                background: `linear-gradient(to right, #F8B731 ${winLimit}%, #6B7280 ${winLimit}%)`
                            }}
                        />
                    </div>

                    <div className="flex flex-col items-center w-full max-w-screen-xl mt-2 xs:my-0 lg:my-4 2xl:my-8">
                        {/* Balance decreases by (amount based on lossLimit) */}
                        <div className="flex items-center justify-between w-full mb-1">
                            <span className="font-semibold">Balance decreases by</span>
                            <span className="font-semibold">
                                {lossLimit === 0 ? balance.toFixed(2) : (balance - ((lossLimit / 100) * balance)).toFixed(2)}
                            </span>
                        </div>
                        <input
                            type="range"
                            min="0"
                            max={balance}  // Only goes up to balance
                            value={(lossLimit / 100) * balance}  // Value reflects lossLimit percentage
                            onChange={(e) => setLossLimit((Number(e.target.value) / balance) * 100)}  // Convert back to percentage
                            disabled={!autoSpin}
                            className={`w-full h-2 rounded-lg appearance-none cursor-pointer transition-all ${autoSpin ? sliderThumbClass : "bg-gray-500 opacity-50 cursor-not-allowed"
                                }`}
                            style={{
                                background: `linear-gradient(to right, #F8B731 ${(lossLimit / 100) * 100}%, #6B7280 ${(lossLimit / 100) * 100}%)`
                            }}
                        />
                    </div>

                    <div className="flex flex-col items-center w-full max-w-screen-xl mt-2 xs:my-0 lg:my-4 2xl:my-8">
                        {/* Balance increases by (amount based on winLimit) */}
                        <div className="flex items-center justify-between w-full mb-1">
                            <span className="font-semibold">Balance increases by</span>
                            <span className="font-semibold">
                                {winLimit === 0 ? balance.toFixed(2) : (balance + ((winLimit / 100) * balance)).toFixed(2)}
                            </span>
                        </div>
                        <input
                            type="range"
                            min={0}
                            max={balance}  // Only goes up to balance
                            value={(winLimit / 100) * balance}  // Value reflects winLimit percentage
                            onChange={(e) => setWinLimit((Number(e.target.value) / balance) * 100)}  // Convert back to percentage
                            disabled={!autoSpin}
                            className={`w-full h-2 rounded-lg appearance-none cursor-pointer transition-all ${autoSpin ? sliderThumbClass : "bg-gray-500 opacity-50 cursor-not-allowed"
                                }`}
                            style={{
                                background: `linear-gradient(to right, #F8B731 ${(winLimit / 100) * 100}%, #6B7280 ${(winLimit / 100) * 100}%)`
                            }}
                        />
                    </div>

                    <div className="flex justify-between items-center w-full mt-2">
                        {/* AutoSpin Toggle */}
                        <button onClick={() => setAutoSpin(!autoSpin)}>
                            <img
                                src={autoSpin ? "/on.png" : "/off.png"}
                                alt={autoSpin ? "AutoSpin ON" : "AutoSpin OFF"}
                                className="xs:w-12 xs:h-7 md:w-16 md:h-10 xl:w-20 xl:h-12 2xl:w-28 2xl:h-16 3xl:w-40 3xl:h-24"
                            />
                        </button>

                        {/* Balance (only visible if autoSpin is ON) */}
                        {autoSpin && (
                            <div className="font-semibold text-[#F8B731]">
                                Balance: {balance.toFixed(2)}
                            </div>
                        )}
                    </div>

                </div>

                {/* Dotted Divider */}
                <div className="border-dotted border-l border-gray-500 h-[calc(100%-30px)]"></div> {/* Vertical for md+ */}

                {/* Bet Amount Section */}
                <div className="xs:p-1 lg:p-3 xs:mx-1 md:mx-3 lg:mx-8 2xl:mx-20 w-full flex flex-col items-center xs:text-xs md:text-md lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl">
                    <div className="xs:mb-2 lg:mb-4 text-center font-semibold">Start AutoSpin</div>
                    <div className="grid grid-cols-4 xs:gap-2 md:gap-5 place-content-center">
                        {autoSpins.map((amount) => (
                            <button
                                key={amount}
                                className={`xs:px-1 md:px-2 xl:px-4 xs:py-1 md:py-3 xl:py-4 rounded-lg shadow-lg uppercase tracking-widest font-extrabold text-gray-700 flex items-center justify-center
                                ${countAutoPlay === amount ? "bg-yellow-500" : "bg-white border border-gray-400 hover:bg-yellow-200"}`}
                                onClick={() => setCountAutoPlay(amount)}
                            >
                                {amount === -1 ? (
                                    <img
                                        src="/infinity.png"
                                        alt="Infinity"
                                        className="w-[90%] h-[90%]"
                                    />
                                ) : amount}

                            </button>
                        ))}
                    </div>

                    <div className="flex flex-col items-center w-full max-w-screen-xl xs:my-2 lg:my-4">
                        <div className="flex items-center justify-between w-full mb-2 px-2.5">
                            <span className="font-semibold">Spins</span>
                            <span className="font-semibold">
                                {countAutoPlay === 0 || countAutoPlay === -1 ? (
                                    <img
                                        src="/infinity-white.png"
                                        alt="Infinity"
                                        className="xs:w-6 xs:h-3 sm:w-7 sm:h-4 md:w-8 md:h-5"
                                    />
                                ) : (
                                    `${countAutoPlay}`
                                )}
                            </span>
                        </div>
                        <input
                            type="range"
                            min="0"
                            max="1000"
                            value={countAutoPlay === -1 ? 0 : countAutoPlay}
                            onChange={(e) => setCountAutoPlay(Number(e.target.value))}
                            className={`w-[95%] h-2 rounded-lg appearance-none cursor-pointer transition-all ${sliderThumbClass} `}
                            style={{
                                background: `linear-gradient(to right, #F8B731 ${countAutoPlay / 10}%, #6B7280 ${countAutoPlay / 10}%)`
                            }}
                        />
                    </div>

                    <button
                        className='lg:m-2 xs:py-2 lg:py-3 xl:py-4 rounded-lg shadow-lg bg-green-500 w-[85%]'
                        onClick={handleAutoPlay}
                    >
                        Auto Spin
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AutoPlay